import React from 'react';
import { useAuth } from '../../context/AuthContext';
import './NavUserProfile.css';

function NavUserProfile() {
  const { user } = useAuth();

  if (!user) return null;

  const rawName = (user.username && user.username.trim()) || user.email || 'User';
  const displayName = rawName.charAt(0).toUpperCase() + rawName.slice(1).toLowerCase();
  const initial = rawName.charAt(0) || 'U';
  const letter = String(initial).toUpperCase();

  return (
    <div className="nav-user-profile">
      <div className="nav-user-profile-avatar" aria-hidden="true">
        {letter}
      </div>
      <div className="nav-user-profile-info">
        <span className="nav-user-profile-name">{displayName}</span>
        <span className="nav-user-profile-role">User</span>
      </div>
    </div>
  );
}

export default NavUserProfile;
